<app-breadcrumb [cmsPage]="cmsPage"></app-breadcrumb>

<section class="section my-3">
  <div class="container">
    <div class="row">
      <div class="col-md-9">
        <div class="card card-shadow">
          <div class="card-body">
            <h1 *ngIf="cmsPage" class="h5 text-default fw-bold border-bottom pb-3 mb-3">{{cmsPage.title}}</h1>
            <div *ngIf="cmsPage?.content" [innerHtml]="newContent"></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mt-3">
        <app-single-page-sidebar [cmsPage]="cmsPage"></app-single-page-sidebar>
      </div>
    </div>
  </div>
</section>